/**
 * Push an event to the window data layer to be used by GTM
 */
export const gtmEvent = (eventName, payload = {}) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    ...payload,
  });
};
